import { useMutation, useQueryClient } from "@tanstack/react-query";
import { portfolioApi } from "./index";

export const usePortfolios = () => {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: async ({ params }: { params?: Record<string, any> }) => {
      return await portfolioApi.fetchPortfolios(params);
    },
    onSuccess: async () => {
      await qc.refetchQueries({ queryKey: ["user-context"] });
    },
  });
};

export const useCreatePortfolio = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ payload }: { payload: any }) => {
      return await portfolioApi.createPortfolio({ payload });
    },
    onSuccess: async () => {
      await qc.refetchQueries({ queryKey: ["user-context"] });
    },
  });
};

export const useEditPortfolio = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({
      portfolioId,
      payload,
    }: {
      portfolioId: string;
      payload: any;
    }) => {
      return await portfolioApi.editPortfolio({ portfolioId, payload });
    },
    onSuccess: async () => {
      await qc.refetchQueries({ queryKey: ["user-context"] });
    },
  });
};
